import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../core/services/global.service';
import { ApiService } from '../../../core/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-report-html',
  templateUrl: './report-html.component.html',
  styleUrls: ['./report-html.component.scss']
})

export class ReportHtmlComponent implements OnInit {
  reportDataObj: any;
  routeSub: Subscription;
  tripListArray;
  reportTitle;
  reportCreatedBy;
  reportCreatedOn;
  reportTotalAmount;
  reportTotalDistance;
  isKilometers;
  currencyCode;
  latitude: number;
  longitude: number;
  customStyle = [
    {
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#f5f5f5'
        }
      ]
    },
    {
      'elementType': 'labels.icon',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'elementType': 'labels.text.fill',
      'stylers': [
        {
          'color': '#616161'
        }
      ]
    },
    {
      'elementType': 'labels.text.stroke',
      'stylers': [
        {
          'color': '#f5f5f5'
        }
      ]
    },
    {
      'featureType': 'administrative.land_parcel',
      'elementType': 'labels.text.fill',
      'stylers': [
        {
          'color': '#bdbdbd'
        }
      ]
    },
    {
      'featureType': 'poi',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#eeeeee'
        }
      ]
    },
    {
      'featureType': 'poi',
      'elementType': 'labels.text.fill',
      'stylers': [
        {
          'color': '#757575'
        }
      ]
    },
    {
      'featureType': 'poi.park',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#e5e5e5'
        }
      ]
    },
    {
      'featureType': 'poi.park',
      'elementType': 'labels.text.fill',
      'stylers': [
        {
          'color': '#9e9e9e'
        }
      ]
    },
    {
      'featureType': 'road',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#ffffff'
        }
      ]
    },
    {
      'featureType': 'road.arterial',
      'elementType': 'labels.text.fill',
      'stylers': [
        {
          'color': '#757575'
        }
      ]
    },
    {
      'featureType': 'road.highway',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#dadada'
        }
      ]
    },
    {
      'featureType': 'road.highway',
      'elementType': 'labels.text.fill',
      'stylers': [
        {
          'color': '#616161'
        }
      ]
    },
    {
      'featureType': 'road.local',
      'elementType': 'labels.text.fill',
      'stylers': [
        {
          'color': '#9e9e9e'
        }
      ]
    },
    {
      'featureType': 'transit.line',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#e5e5e5'
        }
      ]
    },
    {
      'featureType': 'transit.station',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#eeeeee'
        }
      ]
    },
    {
      'featureType': 'water',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#c9c9c9'
        }
      ]
    },
    {
      'featureType': 'water',
      'elementType': 'labels.text.fill',
      'stylers': [
        {
          'color': '#9e9e9e'
        }
      ]
    }
  ];
  j = 1;
  public renderOptions = {
    suppressMarkers: true,
  }

  constructor(
    private globalService: GlobalService,
    private apiService: ApiService,
    private toastr: ToastrService,
    private route: ActivatedRoute) {
    this.tripListArray = [];
  }

  ngOnInit() {
    this.routeSub = this.route.params.subscribe(params => {
      this.getReportData({ reportId: params['id'], created_by: 1 }, true);
    });
    this.setCurrentPosition();
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }

  private setCurrentPosition() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
      });
    }
  }

  getReportData(obj, toastCheck) {
    this.tripListArray = [];
    this.globalService.showSpinner();
    this.apiService.getReportHtml(obj).subscribe(
      resp => {
        this.globalService.hideSpinner();
        if (resp.status == 0) {
          this.toastr.clear();
          this.toastr.error(resp.message, 'Error');
          return;
        }
        this.reportTitle = resp.data.reportName;
        this.reportCreatedBy = resp.data.reportCreatedBy;
        this.reportCreatedOn = resp.data.reportCreatedOn;
        this.reportTotalAmount = resp.data.totalAmount;
        this.reportTotalDistance = resp.data.totalDistance;
        this.isKilometers = resp.data.isKilometers;
        this.tripListArray = resp.data.trips;
        this.currencyCode = resp.data.currencyCode;
        this.tripListArray.forEach(element => {
          element.markers = [];
          element.markers.push({
            lat: element.startLatitude,
            lng: element.startLongitude,
            draggable: false,
            label: {
              color: '#ffffff',
              text: 'A'
            }
          }, {
            lat: element.endLatitude,
            lng: element.endLongitude,
            draggable: false,
            label: {
              color: '#ffffff',
              text: 'B'
            }
          })
          element.wayPoints.forEach((waypoint, i) => {
            element.wayPoints.splice(i, 1, { location: waypoint.location })
            waypoint.isWayPoint && (element.markers.push(
              {
                lat: waypoint.location.lat,
                lng: waypoint.location.lng,
                draggable: false,
                label: {
                  color: '#ffffff',
                  text: 'P' + this.j
                }
              }),
              this.j = this.j + 1);
          });
        });
        toastCheck && this.toastr.clear();
        toastCheck && this.toastr.success(resp.message, 'Success');
      },
      error => {
        this.globalService.hideSpinner();
      }
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/modules/report/report-html/report-html.component.ts